import { TypeSafeTemplateDelegate } from '../Utility/Handlebars/types';
import type { Display } from './Display';
import displayCompiled from './display.hbs';
import './display.scss';
import './zone.scss';
import playerInactiveCompiled from './player-inactive.hbs';
import './player-inactive.scss';
import previewPlayOverlayCompiled from './preview-play-overlay.hbs';
import './preview-play-overlay.scss';

/**
 * The structure of the data needed by the `display.hbs` template.
 */
interface DisplayTemplateData {
    displays: Array<{
        /** (is never set) */
        css?: string;
        id?: number;
        width: number;
        height: number;
        /** (is never set) */
        isPaused: boolean;

        zones: Array<{
            css?: string;
            id: number;
            width: number;
            height: number;
            x: number;
            y: number;
            z: number;
            defaultImg?: string;
            backgroundColor?: string;
        }>;
    }>;
}

export const displayTemplate: TypeSafeTemplateDelegate<DisplayTemplateData> = displayCompiled;

interface PlayerInactiveContext {
    messageTitle: string;
    messageContent: string;
}

export const playerInactiveTemplate: TypeSafeTemplateDelegate<PlayerInactiveContext> =
    playerInactiveCompiled;

export const previewPlayOverlayTemplate: TypeSafeTemplateDelegate<undefined> =
    previewPlayOverlayCompiled;

/**
 * Extract the data needed by the Displays template from {@link Display}/{@link Zone}.
 */
export function getTemplateData(displays: Display[]): DisplayTemplateData {
    return {
        displays: displays.map((display) => {
            return {
                css: undefined,
                id: display.id ?? NaN,
                width: display.width ?? NaN,
                height: display.height ?? NaN,
                isPaused: false,
                zones:
                    display.zones?.map((zone) => {
                        return {
                            css: zone.css ?? undefined,
                            id: zone.id,
                            width: zone.width,
                            height: zone.height,
                            x: zone.x,
                            y: zone.y,
                            z: zone.z,
                            defaultImg: zone.backgroundImage ?? undefined,
                            backgroundColor: zone.backgroundColor ?? undefined,
                        };
                    }) ?? [],
            };
        }),
    };
}
